import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './Spinner.scss';

const spinner = cx({
    [Styles.spinner]: true,
    [Styles.animating]: true
});

const Spinner = () => (
  <div className={spinner}>
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
    <div className={Styles.spinner__item} />
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/Spinner/Spinner.tsx